module.exports = __webpack_public_path__ + "static/media/rectangle_red_mob.5574c89f.svg";